// eslint-disable-next-line no-restricted-imports
import { Record, Set } from '@gonfalon/immutable-shim/immutableShim';

type MemberTeamsType = { customRoleKeys: Set<string>; key: string; name: string };

export class MemberTeams extends Record<MemberTeamsType>({
  customRoleKeys: Set(),
  key: '',
  name: '',
}) {
  hasTeamCustomRoles() {
    return !this.customRoleKeys.isEmpty();
  }
}
